import React from 'react';
import Box from '@mui/material/Box';
import RouteTitle from './RouteTitle'; // Adjust the import path as necessary
import Banner from './Banner'; // Import the Banner component
import { useMediaQuery } from '@mui/material';

const PaddedBox = ({ children, title, showBanner = false }) => {
    const isMobile = useMediaQuery('(max-width:950px)');

    return (
        <Box sx={{ 
            paddingLeft: isMobile ? 2 : 10, 
            paddingRight: isMobile ? 2 : 10, 
            paddingTop: 4, 
            paddingBottom: 10,
            maxWidth: '1400px',
            margin: '0 auto'
        }}>
            {showBanner && (
                <Banner title="Don't miss out! Unlock all lessons for just $59.99!" route="/some-route" />
            )}
            {title && (
                <>
                    <RouteTitle title={title}/>
                    <Box sx={{ height: 30 }} />
                </>
            )}
            {children}
        </Box>
    );
};

export default PaddedBox;